<div class="content-page">
  <div class="quickorder-content">
    <ish-breadcrumb />
    <div class="row">
      <div class="col-md-12">
        <h1>{{ 'dias.quickorder.page.title' | translate }}</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-12">
        @if (isLoggedIn$ | async) {
        <custom-quickorder-order-template-list [orderTemplates]="orderTemplates$ | async" />
        }
      </div>
    </div>
    <custom-quickorder-upload />
    <ish-skip-content-link linkText="common.skip_content.link.text.form">
      <custom-quickorder-add-products-form />
    </ish-skip-content-link>
    <!-- <ish-loading *ngIf="loading$ | async"></ish-loading> -->
  </div>
</div>
